import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { setToken } from "../lib/auth";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { KeyRound } from "lucide-react";

/** Lets the signed-in owner change their own login email and password. */
export const OwnerPasswordCard = () => {
  const { t } = useI18n();
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", email: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: form.current,
        new_password: form.next,
        new_email: form.email.trim() || null,
      });
      setToken(data.access_token);
      setForm({ current: "", next: "", email: "" });
      toast.success(`${t("password_changed")} ${data.email}`);
    } catch (e) {
      toast.error(errMsg(e, "Gagal mengganti kata sandi"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="bg-white border border-gray-200 rounded-2xl p-5 space-y-3"
      data-testid="owner-password-card"
    >
      <p className="font-display font-semibold flex items-center gap-2">
        <KeyRound size={18} className="text-primary" /> {t("owner_account")}
      </p>
      <p className="text-xs text-muted-foreground">
        {t("owner_account_hint")} {user?.email}
      </p>
      <Input
        data-testid="current-password-input"
        type="password"
        placeholder={t("current_password")}
        value={form.current}
        onChange={(e) => setForm({ ...form, current: e.target.value })}
      />
      <Input
        data-testid="new-password-input"
        type="password"
        placeholder={t("new_password")}
        value={form.next}
        onChange={(e) => setForm({ ...form, next: e.target.value })}
      />
      <Input
        data-testid="new-email-input"
        type="email"
        placeholder={t("new_email")}
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <Button
        data-testid="change-password-btn"
        disabled={busy || !form.current || form.next.length < 8}
        onClick={submit}
      >
        {t("change_password")}
      </Button>
    </div>
  );
};
